import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveCalendarIntegration } from "../actions/eventsAction";
import { apiAction, dataAction, staticAction } from "actions/actionWrappers";
import { actions } from "reducers/authReducer";
import { actions as profileActions } from "reducers/profileReducer";
import { myFirebase } from "../firebase/firebase";
import { emailExistsInSystem, getCurrentProfileByGoogle } from "api";

const CalendarCallback = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { isVerifying } = useSelector(state => state.auth);
  const [fbResolved, setFbResolved] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  const getUserProfileWithGoogleLogin = () => async dispatch => {
    try {
      const profile = await dispatch(apiAction(getCurrentProfileByGoogle));
      dispatch(
        dataAction(
          profileActions.ADD_DISPLAY_NAME,
          `${profile.firstName} ${profile.lastName}`
        )
      );
      await dispatch(dataAction(actions.GOOGLE_LOGIN_SUCCESS, profile));
    } catch (err) {
      console.error("❌ Error fetching Google profile:", err);
    }
  };

  const verifyAuth = () => dispatch => {
    dispatch(staticAction(actions.VERIFY_REQUEST));
    const unsubscribeHandler = myFirebase.auth().onAuthStateChanged(async fbUser => {
      try {
        if (fbUser) {
          setUserEmail(fbUser.email);

          if (!fbUser.emailVerified) {
            dispatch(
              dataAction(actions.EMAIL_LOGIN_FAILURE, "Email Not Verified")
            );
          }

          dispatch(
            dataAction(profileActions.ADD_DISPLAY_NAME, fbUser.displayName)
          );

          const { userExist } = await dispatch(
            apiAction(emailExistsInSystem, fbUser.email || "")
          );

          if (userExist) {
            dispatch(getUserProfileWithGoogleLogin());
          } else {
            await dispatch(dataAction(actions.GOOGLE_LOGIN_SIGNUP_SUCCESS));
          }
        } else {
          console.warn("⚠️ No Firebase user detected");
        }

        dispatch(staticAction(actions.VERIFY_SUCCESS));
      } catch (err) {
        console.error("❌ Error in verifyAuth:", err);
        dispatch(staticAction(actions.VERIFY_SUCCESS));
      } finally {
        unsubscribeHandler();
        setFbResolved(true);
      }
    });
  };

  // Step 1: Verify auth when entering this route
  useEffect(() => {
    dispatch(verifyAuth());
  }, [dispatch]);

  // Step 2: Once fbUser is resolved + auth is verified, process integration
  useEffect(() => {
    if (!fbResolved || isVerifying) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    let provider = params.get("state");
    if (!provider) {
      provider = "google";
    }

    if (code && userEmail) {
      const payload = {
        provider,
        code,
        email: userEmail,
        raw_response: Object.fromEntries(params.entries()), // keep everything
      };

      dispatch(saveCalendarIntegration(payload))
        .then(res => {
          console.log("🎉 Calendar integration saved successfully:", res);
          history.push("/mentorship");
        })
        .catch(err => {
          console.error("❌ Error while saving calendar integration:", err);
          history.push("/learninghub");
        });
    } else if (!userEmail) {
      history.push("/signin");
    } else {
      history.push("/learninghub");
    }
  }, [dispatch, history, isVerifying, fbResolved]);

  return (
    <div>
      {!fbResolved || isVerifying
        ? "Checking authentication with Firebase..."
        : "Connecting your calendar..."}
    </div>
  );
};

export default CalendarCallback;
